import { TReferralCredits } from "@/components/Checkout/handlers";
import { toMajorUnits } from "@/utils/toMajorUnits";
import { useCallback, useState } from "react";

interface UseReferralCreditFieldOptions {
  referralCredits?: TReferralCredits;
  disabled?: boolean;
  currency?: string;
}

export function useReferralCreditField({
  referralCredits,
  disabled = false,
  currency,
}: UseReferralCreditFieldOptions) {
  const [isUsed, setIsUsed] = useState(false);

  const claimableCredit = toMajorUnits(
    referralCredits?.amount_off ?? 0,
    currency,
  );
  const totalCredit = toMajorUnits(
    referralCredits?.total_credits ?? 0,
    currency,
  );
  const hasCredits = claimableCredit > 0;

  const use = useCallback(() => setIsUsed(true), []);
  const remove = useCallback(() => setIsUsed(false), []);
  const toggle = useCallback(() => setIsUsed((prev) => !prev), []);

  return {
    isUsed,
    claimableCredit,
    totalCredit,
    hasCredits,
    use,
    remove,
    toggle,
    bannerProps: {
      totalPoints: totalCredit,
      usableCredit: claimableCredit,
      isUsed,
      onToggle: toggle,
      disabled,
    },
  };
}
